import { DeviceStatusString } from '@emfit/shared-types';

export function getCareStatus(status: number): DeviceStatusString {
  switch (status) {
    case 1: // DeviceStatus.Absence
      return 'outOfBed';
    case 2: // DeviceStatus.Presence
      return 'inBed';
    case 3: // DeviceStatus.NetworkError
    case 4: // DeviceStatus.SensorError
      return 'error';
    case 0: // DeviceStatus.Undeployed
      return 'offline';
    default:
      return 'offline';
  }
}

export function getQsStatus(status: number): DeviceStatusString {
  switch (status) {
    case 0: // DeviceStatus.Undeployed
      return 'offline';
    case 1: // DeviceStatus.Absence
      return 'outOfBed';
    case 2: // DeviceStatus.Presence
      return 'inBed';
    case 3: // DeviceStatus.NetworkError
      return 'offline';
    default:
      return 'offline';
  }
}

export function getStatus(
  app: 'qs' | 'care',
  status: number
): DeviceStatusString {
  if (app === 'qs') {
    return getQsStatus(status);
  } else {
    return getCareStatus(status);
  }
}
